// extracted by mini-css-extract-plugin
module.exports = {"container":"jc","hero":"kc","content":"lc","typeProd":"mc","notTransparent":"nc","sliderDots":"oc","active":"pc"};